import moment, { type MomentInstance } from '~/utils/moment';

export default function useDateDiff(from: MomentInstance, to: MomentInstance): MomentInstance {
    const seconds = to.diff(from, 'seconds');
    return moment().startOf('day').seconds(seconds);
}
